import { Show } from "@refinedev/antd";
import { Tag, Space } from "antd";
import { IResourceComponentsProps, useShow } from "@refinedev/core";
import { GlobalOutlined } from "@ant-design/icons";

import { ICountry } from "interfaces";
import {
  ShowField,
  ShowSection,
  ShowFieldGrid,
} from "components/show";

export const CountryShow: React.FC<IResourceComponentsProps> = () => {
  const { result, query: { isLoading } } = useShow<ICountry>();
  const record = result;

  return (
    <Show
      breadcrumb={false}
      isLoading={isLoading}
      headerProps={{
        onBack: () => window.history.back(),
        subTitle: "active country",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
      }}
    >
      <Space direction="vertical" size={24} style={{ width: "100%" }}>
        <ShowSection
          title="Country Information"
          subtitle="Geographic location details"
          icon={<GlobalOutlined />}
          variant="elevated"
        >
          <ShowFieldGrid columns={3}>
            <ShowField label="Country Name" value={record?.name} />
            <ShowField label="ISO Code" value={record?.isoCode} type="code" copyable />
            <ShowField label="ISO3 Code" value={record?.iso3Code} type="code" copyable />
          </ShowFieldGrid>
        </ShowSection>
      </Space>
    </Show>
  );
};
